import React from 'react'
import { FiArrowRight } from '@react-icons/all-files/fi/FiArrowRight'
import Container from '../foundations/Container'
import Action from '../primitives/Action'
import Media from '../primitives/Media'
import { MEDIA_POLICY_KEYS } from '../primitives/mediaPolicy'
import styles from './EquipmentGuide.module.scss'

const EquipmentGuide = ({
  description = 'Understand the role of each speaker type before comparing individual models.',
  eyebrow = 'Choose by use case',
  headingId = 'speaker-type-guide',
  title,
  items = []
}) => (
  <section className={styles.section} aria-labelledby={headingId}>
    <Container>
      <div className={styles.heading}>
        <span>{eyebrow}</span>
        <h2 id={headingId}>{title}</h2>
        {description && <p>{description}</p>}
      </div>
      <div className={styles.grid}>
        {items.map((item, index) => (
          <article className={`${styles.card} ${index === 0 ? styles.featured : ''}`} key={item.title}>
            <Media
              src={item.image?.src || item.image}
              picture={item.image?.picture}
              alt={item.imageAlt}
              objectPosition={item.image?.position || 'center'}
              policy={MEDIA_POLICY_KEYS.CARD}
              sizes={index === 0
                ? '(max-width: 899px) 100vw, 50vw'
                : '(max-width: 899px) 100vw, 25vw'}
              ratio={index === 0 ? '16 / 10' : '4 / 3'}
              className={styles.media}
            />
            <div className={styles.copy}>
              <span>{item.eyebrow}</span>
              <h3>{item.title}</h3>
              {item.summary && <p className={styles.summary}>{item.summary}</p>}
              <div className={styles.body}>{item.body}</div>
              {item.href && (
                <Action href={item.href} variant='quiet' size='compact' icon={FiArrowRight}>
                  {item.actionLabel}
                </Action>
              )}
            </div>
          </article>
        ))}
      </div>
    </Container>
  </section>
)

export default EquipmentGuide
